import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

export function useGetTasks({ projectId }: { projectId: string }) {
  const { toast } = useToast()

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['project-tasks', projectId],
    queryFn: () =>
      projectService.projectTasks.getTasks({
        projectId,
      }),
  })

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Erro ao buscar tarefas',
        description: 'Por favor, tente novamente mais tarde',
        variant: 'destructive',
      })
    }
  }, [isError, toast])

  if (data) {
    return {
      tasks: data,
      isLoadingGetTasks: isLoading,
      isErrorGetTasks: isError,
      refetchGetTasks: refetch,
    }
  }

  return {
    tasks: [],
    isLoadingGetTasks: isLoading,
    isErrorGetTasks: isError,
    refetchGetTasks: refetch,
  }
}
